export default  {
  bindings: {
    offer: '=',
    title: '@',
    formTab: '='
  },
  controller: 'offerSaveController',
  template: require('../views/offer.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/components/offer.save.component.js